var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { usePresentationComponent } from "../../../AppContext";
import { TIME_SLOTS } from "../../../classConstants";
import { Flex } from "../../Flex";
import { TimeSlotButton } from "./TimeSlotButton";
import isEqual from "date-fns/isEqual";
import { dateFormat, normalizeDate } from "../../../helpers/date";
import { NoDataToDisplay } from "../../NoDataToDisplay/NoDataToDisplay";
import { useTranslation } from "react-i18next";
export var TimeSlotRows = function (props) {
    var t = useTranslation().t;
    var slots = props.slots, selected = props.selected, onSelect = props.onSelect;
    var Renderer = usePresentationComponent("timeslot.timeslotRows") || undefined;
    var renderedButtons = React.useMemo(function () { return slots.map(function (slot, i) { return (React.createElement(TimeSlotButton, { className: TIME_SLOTS.ALL_SLOTS, slot: slot, active: isEqual(slot.from, normalizeDate(selected.from)), disabled: !slot.isAvailable, key: i, onClick: onSelect })); }); }, [slots, selected, onSelect]);
    if (props.hideSlotSelection && selected) {
        return React.createElement(NoDataToDisplay, { className: TIME_SLOTS.TIME_SLOT_HIDDEN, message: t("bookcart.timeslots.only_one_slot_available", {
                from: function () { return dateFormat(new Date(selected.from), t("bookcart.timeslots.timeslot_format")); },
                to: function () { return dateFormat(new Date(selected.to), t("bookcart.timeslots.timeslot_format")); },
                skipInterpolation: true
            }) });
    }
    if (renderedButtons.length <= 0)
        return React.createElement(NoDataToDisplay, { message: t("bookcart.timeslots.all_timespans_booked_out") });
    return (React.createElement(SlotRows, { forwardedAs: Renderer },
        renderedButtons,
        " "));
};
var SlotRows = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: var(--ws-input-margin) -5px;\n"], ["\n    margin: var(--ws-input-margin) -5px;\n"])));
var templateObject_1;
